import React, {Suspense, useState} from 'react';
// import PageBouncingLoader from '../../../stories/pages/ShimmerLoader/PageBouncingLoader/PageBouncingLoader';
import useIntersectionObserver from '@stencil/use-intersection-observer';
import QnALoader from '../../../../stories/components/hotels/Loadingpage/QnA/QnAAllComponent/QnAAllComponent';
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

const QnAComponent = React.lazy(() => import('./QnA'));

const QnAChunk = () => {
  return (
    <Suspense fallback={<QnALoader />}>
      <QnAComponent />
    </Suspense>
  );
};

const intersectionObserverOptions = {
  root: null,
  threshHold: 0.01,
};

const QnA = () => {
  const [visible, setVisible] = useState(false);

  const [watcherRef] = useIntersectionObserver(intersectionObserverOptions, () => {
    setVisible(true);
  });

  return (
    <div ref={watcherRef} id={detailsNavigationIds.QnA}>
      {(visible && <QnAChunk />) || null}
    </div>
  );
};

export default QnA;
